import { filterClasses } from "@swivl-mono/helpers";
import { AnimatePresence, motion } from "motion/react";
import { useRef, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import useAutoFocus from "../../../../Hooks/useAutoFocus";
import useKeyPressAction from "../../../../Hooks/useKeyPressAction";
import { ConversationUserListTabsStateType } from "../../ConversationsView";

interface EscalationsHeaderProps {
  conversationSearchTerm: string;
  setConversationsSearchTerm: (searchTerm: string) => void;
  tabState: ConversationUserListTabsStateType;
  setTab: (state: ConversationUserListTabsStateType, fromClick?: boolean) => void;
}

export function ConversationsUserListColumnHeader({ setConversationsSearchTerm, conversationSearchTerm, tabState, setTab }: EscalationsHeaderProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  useKeyPressAction({
    key: "Escape",
    callback: () => setIsSearchOpen(false),
    targetEl: inputRef.current,
  })
  useAutoFocus(inputRef, [isSearchOpen]);

  const handleClearSearch = () => {
    setConversationsSearchTerm("");
  }

  const handleToggleSearch = () => {
    handleClearSearch();
    setIsSearchOpen(!isSearchOpen);
  };

  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }

  const isOpen = tabState !== ConversationUserListTabsStateType.Closed;

  return (
    <div className="flex items-center justify-between h-12 gap-6 px-4 bg-white border-b border-gray-200">
      {/* escalation status tabs */}
      <div className="my-4 font-semibold text-sm px-4 gap-8 flex items-center relative h-full">
        <button
          className="hover:text-red-500 duration-100 transition-colors"
          onClick={() => setTab(ConversationUserListTabsStateType.Open, true)}
        >
          Open
        </button>
        <button
          className="hover:text-red-500 duration-100 transition-colors"
          onClick={() => setTab(ConversationUserListTabsStateType.Closed, true)}
        >
          Closed
        </button>
        <div className={filterClasses("absolute transition-transform ease-in-out duration-300 bottom-0 h-[3px] w-16 bg-orange-500",
          isOpen ? "-translate-x-3.5" : "translate-x-[49.5px]"
        )} />
      </div>

      {/* search bar */}
      <div
        className={filterClasses("border p-4 border-grey-400 rounded-full flex items-center relative overflow-hidden transition-all duration-300 ease-in-out",
          isSearchOpen ? "h-7 max-w-64" : "h-7 max-w-7 justify-center rounded-full",
        )}
      >
        <input
          className={filterClasses(
            // TODO: figure out padding for search
            "outline-none text-sm leading-3 caret-orange-500 min-w-0 transition-all pr-10 sm:pr-[50px] duration-300 ease-in-out",
            isSearchOpen ? "w-56 opacity-100" : "w-0 opacity-0"
          )}
          onChange={(e) => setConversationsSearchTerm(e.target.value)}
          placeholder="Search..."
          ref={inputRef}
          value={conversationSearchTerm}
        />
        <AnimatePresence mode="wait">
          {isSearchOpen && (
            <motion.button
              animate="visible"
              key="clearButton"
              initial="hidden"
              exit="hidden"
              variants={fadeVariants}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="absolute right-7 flex items-center justify-center rounded-md text-sm hover:text-orange-500 transition-colors duration-200"
              onClick={handleClearSearch}
            >
              Clear
            </motion.button>
          )}
        </AnimatePresence>
        <button
          className={filterClasses(
            "absolute right-1 z-50 size-6 flex items-center justify-center rounded-full text-black hover:text-orange-500 transition-colors duration-200",
          )}
          onClick={handleToggleSearch}
        >
          {isSearchOpen ? (
            <IoClose className="size-5 text-inherit stroke-2" />
          ) : (
            <FaSearch className="size-3 text-inherit stroke-2" />
          )}
        </button>
      </div>
    </div>

  )
}


